import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExtend = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	overflow: "visible",
	style: { display: "block" },
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "arrows_outward",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_0_4",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 24,
			height: 24,
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Bounding box",
				width: 24,
				height: 24
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_0_4)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "arrows_outward_2",
				d: "M17 17L15.6 15.6L18.175 13H13V11H18.175L15.6 8.4L17 7L22 12L17 17ZM7 17L2 12L7 7L8.4 8.4L5.825 11H11V13H5.825L8.4 15.6L7 17Z",
				fill: "currentColor"
			})
		})]
	})
});
export default SvgExtend;
